import React from "react";
import { Layout, Row, Col } from "antd";
import HeaderNavigationContainer from "../../components/HeaderNavigation/container";
import BlogBlock from "../../components/BlogBlock";
import FooterContainer from "../../components/Footer/container";
import Loader from "../../components/Loader";
import {getBackgroundImage} from '../../infrastructure/helpers/getBackgroundImage'
const { Header, Content } = Layout;

function Blog(props) {
 
  const { posts } = props;
  const postList = Object.keys(posts).map(key => (
    <BlogBlock
      key={key}
      img={posts[key].coverImage}
      author={posts[key].author}
      headline={posts[key].title}
      body={posts[key].highlightText}
      createTime={posts[key].createTime.toString().split(" ", 4)}
      displayReadMore
      language={props.language}
      readMoreLink={`/blog/${key}`}
      maxHeight="144px"
    />
  ));
  return (
    <Layout
      className="layout homebg"
      style={{
        background: `url(${getBackgroundImage('blog')}) no-repeat bottom center fixed`,
        backgroundSize: "cover"
      }}
    >
      <HeaderNavigationContainer />
      <Header>
        <div
          style={{
            color: "#fff",
            position: "relative",
            width: "100%",
            bottom: 0,
            marginTop: "10%"
          }}
        >
          <h1 className="header_headline">Blog</h1>
          <div
            style={{
              position: "absolute",
              zIndex: 1000,
              margin: "0 auto",
              left: 0,
              right: 0,
              marginTop: "-23px"
            }}
          >
            <button
              onClick={() => window.scrollBy(0, 700)}
              className="arrow_button"
            >
              <i className="arrow arrow_down" />
            </button>
          </div>
        </div>
      </Header>
      <Content>
        {props.loading ? (
          <Row
            style={{ backgroundColor: "#fff", color: "#000", padding: "50px" }}
          >
            <Col sm={24} md={{ span: 16, offset: 4 }}>
              <Loader />
            </Col>
          </Row>
        ) : (
          postList
        )}
      </Content>
      <FooterContainer />
    </Layout>
  );
}
export default Blog;

Blog.defaultProps = {
  posts: []
};



// WEBPACK FOOTER //
// ./src/pages/Blog/Page.js